function u(l) {
  throw new Error("Unexpected object: " + l);
}
var c = function (i) {
  return i[i.First = 0] = "First", i[i.Previous = 1] = "Previous", i[i.Next = 2] = "Next", i[i.Last = 3] = "Last", i[i.Specific = 4] = "Specific", i[i.Nothing = 5] = "Nothing", i;
}(c || {});
function f(l, n) {
  var t = n.resolveItems();
  if (t.length <= 0) return null;
  var r = n.resolveActiveIndex(),
    s = r != null ? r : -1;
  switch (l.focus) {
    case 0:
      {
        for (var e = 0; e < t.length; ++e) if (!n.resolveDisabled(t[e], e, t)) return e;
        return r;
      }
    case 1:
      {
        for (var _e = s - 1; _e >= 0; --_e) if (!n.resolveDisabled(t[_e], _e, t)) return _e;
        return r;
      }
    case 2:
      {
        for (var _e2 = s + 1; _e2 < t.length; ++_e2) if (!n.resolveDisabled(t[_e2], _e2, t)) return _e2;
        return r;
      }
    case 3:
      {
        for (var _e3 = t.length - 1; _e3 >= 0; --_e3) if (!n.resolveDisabled(t[_e3], _e3, t)) return _e3;
        return r;
      }
    case 4:
      {
        for (var _e4 = 0; _e4 < t.length; ++_e4) if (n.resolveId(t[_e4], _e4, t) === l.id) return _e4;
        return r;
      }
    case 5:
      return null;
    default:
      u(l);
  }
}
export { c as Focus, f as calculateActiveIndex };